import { ProjectSwitcher } from './ProjectSwitcher';
import styles from './ContextStrip.module.css';

/**
 * Below 768px the top bar hides the project switcher, so this one line names the project the person is working in (all
 * projects, a home project, a foreign project with its organization) and opens the same picker. The only context
 * signal on a small screen; the Shared badge of a foreign workspace is part of its label.
 */
export function ContextStrip() {
  return (
    <div className={styles.strip}>
      <ProjectSwitcher variant="strip" />
    </div>
  );
}
